import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { api } from "@/lib/api";

const TONE = { Active: "bg-[#E3EDE7] text-[#0F3D2E]", "Needs credentials": "bg-[var(--sand)]", "Needs licensing agreement": "bg-[var(--sand)]", "Not permitted": "bg-[#FDECEA] text-[#B42318]" };

export const ImportSources = () => {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { if (open && !rows) api.get("/import/providers").then((r) => setRows(r.data)); }, [open, rows]);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button type="button" className="btn-quiet text-xs" data-testid="import-sources-button">Import sources</button>
      </DialogTrigger>
      <DialogContent className="max-h-[85vh] max-w-lg overflow-y-auto bg-[var(--bone)]" data-testid="import-sources-panel">
        <DialogHeader><DialogTitle className="font-display text-2xl">Import sources</DialogTitle></DialogHeader>
        <p className="text-xs text-[var(--stone-dark)]">Where listing photos can come from — and why some never will. Listing portals are never fetched.</p>
        <ul className="mt-2 divide-y divide-[var(--line)]">
          {(rows || []).map((r) => (
            <li key={r.id} className="py-3" data-testid={`import-source-${r.id}`}>
              <div className="flex items-start justify-between gap-3">
                <span className="text-sm font-medium">{r.name}</span>
                <span className={`shrink-0 rounded-full px-2 py-0.5 text-[0.65rem] ${TONE[r.status] || ""}`} data-testid={`import-source-status-${r.id}`}>{r.status}</span>
              </div>
              <div className="mt-1 text-xs leading-relaxed text-[var(--ink-soft)]">{r.photoCapability} · {r.licenseBasis}{r.reason ? ` — ${r.reason}` : ""}</div>
              <div className="text-[0.68rem] text-[var(--stone-dark)]">Attribution: {r.attributionRule}</div>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
